import AccordionItem from './AccordianItem'
import { useState } from 'react';
const Accordion = ({ items }) => {  
    const [activeAccordian, setActiveAccordian] = useState(0)
    const activateAccordian = (index) => {
        index === activeAccordian ? setActiveAccordian(null) : setActiveAccordian(index)
    }
    const renderItems = items.map((item, index) => {
                            return (
                               <AccordionItem key={index} item={item} active={activeAccordian === index} onClick={activateAccordian} index={index}/>
                            )
                        })
   

    return (
        <div className="accordian-container">
            {renderItems}
        </div>
    )
}

export default Accordion;